export const DEFAULT_PERP_LEVERAGE = 1;

export function getDefaultPerpLeverage(maxLeverage: number) {
  return Math.min(maxLeverage, DEFAULT_PERP_LEVERAGE);
}
